import Link from "../../../components/Link";
import { IListviewField } from "../../../services/types";
import { getCurrentUrlAsSource } from "../../../services/utils";
import { CategoryFull } from "./types";
import { dispForm } from "./urls";

export const name: IListviewField<CategoryFull> = {
  title: "Name",
  fieldName: "name",
  isSortable: true,
  renderListValue: (item: CategoryFull) => (
    <Link href={`${dispForm}/${item.id}?${getCurrentUrlAsSource()}`}>{item.name}</Link>
  ),
};
